module.exports = __webpack_public_path__ + "static/img/zhanweiyudingico.8fdb1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zhanweiyudingico.png
// module id = 17NA
// module chunks = 1